export default __webpack_public_path__ + "14b8635e64f17fd2d14ea6d1d357a7f9.svg";